// extracted by mini-css-extract-plugin
export default {"title":"AdvancePaymentDetails_title__87Ppj","total":"AdvancePaymentDetails_total__greZk","edit":"AdvancePaymentDetails_edit__GSpqb"};